// Secret-free project coordinates, kept apart from the fetching client so that
// browser-bundled code (the image URL builder) and tests that mock the client
// can use them without pulling in a token.
export const SANITY_PROJECT_ID = 'th0o92af';
export const SANITY_DATASET = 'production';
export const SANITY_API_VERSION = '2025-04-14';
